module.exports = __webpack_public_path__ + "static/media/mail-outline (1).7ccfc49b.svg";